module.exports = __webpack_public_path__ + "media/promo/hochland/images/bg_m-0bcf3081babaff83198d7408aa074ff4.png";